import { Section, SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/language';
import * as React from 'react';
import './FaqSection.scss';

export interface IFaq {
  question: string;
  answer: string;
}

export interface IFaqsProps {
  data: IFaq[];
}

export const FaqView: React.FC<IFaq> = ({ question, answer }) => (
  <div className="col-6 col-m-4 faq-item">
    <h3 className="question nn-button-medium">{question}</h3>
    <p className="answer">{answer}</p>
  </div>
);

const data: IFaq[] = [
  {
    question: 'FaqSection.Question1',
    answer: 'FaqSection.Answer1',
  },
  {
    question: 'FaqSection.Question2',
    answer: 'FaqSection.Answer2',
  },
  {
    question: 'FaqSection.Question3',
    answer: 'FaqSection.Answer3',
  },
  {
    question: 'FaqSection.Question4',
    answer: 'FaqSection.Answer4',
  },
  {
    question: 'FaqSection.Question5',
    answer: 'FaqSection.Answer5',
  },
  {
    question: 'FaqSection.Question6',
    answer: 'FaqSection.Answer6',
  },
  {
    question: 'FaqSection.Question7',
    answer: 'FaqSection.Answer7',
  },
  {
    question: 'FaqSection.Question8',
    answer: 'FaqSection.Answer8',
  },
];

export const FaqSection: React.FC = () => {
  const { t } = useTranslation();
  const title = t('FaqSection.Title');
  return (
    <Section className="faq-section">
      <SectionTitle>{title}</SectionTitle>
      <div className="row faq-items">
        {data.map((faq) => (
          <FaqView answer={t(faq.answer)} question={t(faq.question)} key={faq.question} />
        ))}
      </div>
    </Section>
  );
};

export default FaqSection;
